/**
 * Roles & access — operator-portal variant (COL-352 Phase 6).
 *
 * Operators get their OWN team roster (OperatorTeamRoster), grouped by the
 * within-org member_role (Super Admins / Admins) — not the platform app_role,
 * which is "operator" for every member. The roster is RLS-scoped to the org
 * (operator_members + operator_person_read). None of the staff panels apply:
 * AdminRoleManagementPanel / AdminPropertyApprovals carry CoLiviq-staff
 * invite/mutation flows. Team invites use OperatorInviteMemberCard, wired to
 * the super_admin-gated operator-invite-member edge function.
 */
import { useLanguage } from "@/contexts/LanguageContext";
import { OperatorTeamRoster } from "@/components/admin/OperatorTeamRoster";
import { OperatorInviteMemberCard } from "@/components/admin/OperatorInviteMemberCard";
import { OperatorContactCard } from "@/components/admin/OperatorContactCard";

export function OperatorSettings() {
  const { t } = useLanguage();
  return (
    <div className="space-y-10 pb-8">
      <div className="space-y-2">
        <h1 className="text-3xl font-semibold tracking-tight">
          {t("admin.nav.rolesAccess", "Roles & access")}
        </h1>
        <p className="text-muted-foreground max-w-2xl text-sm sm:text-base">
          {t(
            "operator.roles.subtitle",
            "Your team: who can reach what inside your organization."
          )}
        </p>
      </div>

      <section className="space-y-4">
        <OperatorTeamRoster />
        <OperatorInviteMemberCard />
      </section>

      <section className="space-y-4">
        <OperatorContactCard />
        <p className="text-sm text-muted-foreground">
          Contracts: upload your own templates under More → Templates, or use
          the coliviq default — it carries coliviq branding with your own owners
          and representatives.
        </p>
      </section>
    </div>
  );
}
